module.exports = __webpack_public_path__ + "d308073b/img/send-icon.3cfb6275.svg";